import { lazy } from 'react';

export const LazyProgressiveCheckoutSignInPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--progressive-checkout-sign-in-page" */ './progressive-checkout-sign-in-page'
    ),
);
